import React, {useState, useEffect, useRef /*, useContext */ } from 'react';
import { Button, Modal, Form, Input, Select, InputNumber, DatePicker, Checkbox, message } from 'antd';
import { PlusOutlined } from '@ant-design/icons';
import * as Setting from '../utils/AuthUtils';
import { api } from '../AppConfig';
import { composeSelectOptions } from '../utils/ComponentUtils';
import { useTranslation } from 'react-i18next';

function AddTournament(props) {
    const [form] = Form.useForm();
    const [isActive,setIsActive] = useState(false);
    const [confirmLoading, setConfirmLoading] = useState(false);
    const [isLoaded, setIsLoaded] = useState(false);
    const [error, setError] = useState(null);
    const [tournamentTypes, setTournamentsTypes] = useState([]);
    const [tournamentMultipliers, settournamentMultipliers] = useState([]);
    const [leagues, setLeagues] = useState([]);
    const [messageApi, contextHolder] = message.useMessage();
    const { t } = useTranslation();

    useEffect(() => {
        fetch(api.leagues().list({'active': true}).href)
        .then(res => res.json())
        .then(
          (result) => {
            setIsLoaded(true);
            setLeagues(result.payLoad);
          },
          // Note: it's important to handle errors here
          // instead of a catch() block so that we don't swallow
          // exceptions from actual bugs in components.
          (error) => {
            setIsLoaded(true);
            setError(error);
          }
        )
        fetch(api.tournaments().listTypes().href)
          .then(res => res.json())
          .then(
            (result) => {
              setIsLoaded(true);
              setTournamentsTypes(result.payLoad);
            },
            // Note: it's important to handle errors here
            // instead of a catch() block so that we don't swallow
            // exceptions from actual bugs in components.
            (error) => {
              setIsLoaded(true);
              setError(error);
            }
          )
        fetch(api.tournaments().listMultipliers().href)
          .then(res => res.json())
          .then(
            (result) => {
              setIsLoaded(true);
              settournamentMultipliers(result.payLoad);
            },
            // Note: it's important to handle errors here
            // instead of a catch() block so that we don't swallow
            // exceptions from actual bugs in components.
            (error) => {
              setIsLoaded(true);
              setError(error);
            }
          )
        }, [])

    function toggleModal() {
        // console.warn('arrivato a toggle!!');
        if (isActive) {
            setIsActive(false);
        } else {
            setIsActive(true);
        }
    }

    function handleCancel() {
        form.resetFields();
        setIsActive(false);
    }

    function onFinish(values) {
        form.validateFields({ validateOnly: true })
        .then(async () => {
          // values.stageId = props.seasonId
          const stringDate = values.date.format('YYYY-MM-DDTHH:mm:ssZ')
          // values.date = stringDate
          const tournament = {};
          tournament.name = values.name;
          tournament.date = stringDate;
          tournament.type = {};
          tournament.multiplier = {};
          tournament.type.id = values.type;
          tournament.multiplier.id = values.split;
          tournament.playerAttendancy = values.playerAttendancy;
          tournament.playerCap = values.playerCap;
          tournament.turns = values.turns;
          if ((values.type >= 1 && values.type <=3) || values.type == 14) {
            tournament.turns = 3;
          }
          tournament.decklist = values.decklist;
          tournament.leagueOrganizer = values.leagueOrganizer;
          tournament.place = values.place;
          tournament.externalLink = values.externalLink;
          if (values.playerAttendancy >= 8 && values.turns >= 3) {
            tournament.isDone = true;
          }
          tournament.canUploadDecklist = values.canUploadDecklist;
          // console.warn('values della form: ', tournament)

          setConfirmLoading(true);
          const response = await fetch(api.tournaments().create().href, {
            method: 'POST', // *GET, POST, PUT, DELETE, etc.
            mode: 'cors', // no-cors, *cors, same-origin
            cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
            credentials: 'include', // include, *same-origin, omit
            headers: {
              'Content-Type': 'application/json',
              'Authorization': 'Bearer ' + Setting.getToken(),
              // 'Content-Type': 'application/x-www-form-urlencoded',
            },
            redirect: 'follow', // manual, *follow, error
            referrerPolicy: 'no-referrer', // no-referrer, *no-referrer-when-downgrade, origin, origin-when-cross-origin, same-origin, strict-origin, strict-origin-when-cross-origin, unsafe-url
            body: JSON.stringify(tournament) // body data type must match "Content-Type" header
          })
          .then((data) => data.json())
          // .then(() => window.location.reload(false))

          if (response.errorMsg === "") {
              window.location.reload(false);
          } else {
              setConfirmLoading(false);
              messageApi.error("You do not have the permission to create this tournament! Check the inserted infos.");
          }
        })
        .catch((errorInfo) => {
          // console.warn('errorInfo:', errorInfo);
          messageApi.error("Please compile all required fields of the form!");
          }
        )
    }

    // const linkAddStageAdvanced = "/web/seasons/"+props.seasonId+"/addstage";

    return(
            <div>
                {contextHolder}
                <Modal title={t('tournaments.create').toUpperCase()} open={isActive} trigger="click" onOk={form.submit} onCancel={handleCancel} confirmLoading={confirmLoading} maskClosable={false} cancelText="Cancel" okText="Add">
                    <Form form={form} onFinish={onFinish} labelCol={{ span: 8, }} wrapperCol={{ span: 16, }} initialValues={{ split: 2 }}>
                    <Form.Item label={t('tournaments.name')} name="name" rules={[{ required: true, message: 'Please insert a name!' }]}>
                        <Input placeholder={t('tournaments.placeholderName')} />
                    </Form.Item>
                    <Form.Item label={t('tournaments.startDate')} name="date" rules={[{ required: true, message: 'Please insert a date!' }]}>
                        <DatePicker placeholder={t('tournaments.startDate')} format="DD/MM/YYYY" />
                    </Form.Item>
                    <Form.Item label={t('tournaments.labelTO')} name="leagueOrganizer" rules={[{ required: true, message: 'Please select a league!' }]}>
                        <Select placeholder={t('leagues.selectLeague')}>
                            {composeSelectOptions(leagues,{key: 'id', value: 'id', desc: 'leagueName'})}
                        </Select>
                    </Form.Item>
                    <Form.Item label={t('tournaments.type')} name="type" rules={[{ required: true, message: 'Please select a type!' }]}>
                        <Select placeholder={t('tournaments.selectType')}>
                            {composeSelectOptions(tournamentTypes,{key: 'id', value: 'id', desc: 'desc'})}
                        </Select>
                    </Form.Item>
                    <Form.Item label={t('tournaments.place')} name="place">
                        <Input placeholder="Place" />
                    </Form.Item>
                    <Form.Item label={t('tournaments.externalLink')} name="externalLink">
                        <Input placeholder="External Link" />
                    </Form.Item>
                    <Form.Item label={t('tournaments.cap')} name="playerCap">
                        <InputNumber min={8} max={1600} placeholder={t('tournaments.cap')} />
                    </Form.Item>
                    <Form.Item label={t('tournaments.participants')} name="playerAttendancy">
                        <InputNumber min={8} max={1600} placeholder={t('tournaments.participants')} />
                    </Form.Item>
                    <Form.Item label={t('tournaments.turns')} name="turns">
                        <InputNumber min={3} max={15} placeholder='no. of turns' />
                    </Form.Item>
                    <Form.Item label="Split" name="split">
                        <Select placeholder="Select ranking split">
                            {composeSelectOptions(tournamentMultipliers,{key: 'id', value: 'id', desc: 'desc'})}
                        </Select>
                    </Form.Item>
                    <Form.Item label={t('decks.required')} name="canUploadDecklist" valuePropName="checked" tooltip={t('decks.requiredTooltip')}>
                        <Checkbox />
                    </Form.Item>
                    {/* <Form.Item wrapperCol={{ offset: 8, span: 16 }}>
                        <Button type="primary" htmlType="submit">
                            Aggiungi
                        </Button>
                    </Form.Item> */}
                </Form>
                </Modal>
                <Button style={{ marginTop: 16 }} type="primary" icon={<PlusOutlined />} onClick={toggleModal}>
                    {t('tournaments.create').toUpperCase()} 
                </Button>
            </div>
    )
}

export default AddTournament;